<template>
  <div class="hello">
    <div class="header">
      <img src="./../assets/logo.png" alt="" />
    </div>
    <h2>U ime kulture!</h2>
    <div>
      <p class="description">
        Tokom 2019. godine građani su se okupili i sakupili 36.316 potpisa za
        Narodnu inicijativu kako bi ograničili rijaliti programe i izborili se
        za uvodjenje pola sata kulturnog programa za decu i pola sata za
        maloletnike na nacionalnim frekvencijama. Time je zvanično iskorišćeno
        pravo građana da putem narodne inicijative predlože zakon parlamentu.
        Prtivustavno vlast skoro četiri godine ne stavlja narodnu inicijativu na
        glasanje. Svi jasno ukazujemo da nam treba pozitivan obrazac za decu i
        manje nasilja koje se promoviše na TV ekranima, rešenje za taj problem
        predložili smo zajedno sa pravnim ekspertima, sociolozima, psiholozima i
        umetnicima. Vlast govori kako se dogovorila sa željkom Mitrovićem o
        ukidanju rijalitija, da bi on sam objavio da je u pitanju prevara.
        Narodni poslanici bez obzira da li podržavaju vlast ili opozicije, jesu
        predstavnici građana i tražimo da se izjasne da li su da konačno rešimo
        ovo pitanje zakonskim putem. Pišite narodnim poslanicima preko platforme
        koja će poslati poruku svima na mejl. I pogledajte da li su nam
        odgovorili! Tim Kreni - Promeni
      </p>
    </div>
    <div class="hello">
      <div class="container">
        <div class="form" v-if="!msgSent">
          <!-- <div class="container-item">
          <label>Vaše ime</label>
          <input
            type="text"
            v-model="name"
            name="name"
            placeholder="Vaše ime"
          />
          <p v-if="nameError" class="error">Ovo polje je obavezno!</p>
        </div>
        <div class="container-item">
          <label>Vaša email adresa</label>
          <input
            type="email"
            v-model="userEmail"
            name="email"
            placeholder="Vaš email"
          />
          <p v-if="emailError" class="error">Ovo polje je obavezno!</p>
        </div> -->
          <div class="container-item">
            <label>Naslov email-a</label>
            <p class="clickp">
              Klikom na dugmiće ispod možete izabrati neke od predloga naslova
            </p>
            <div class="buttons">
              <button class="option-btn" @click="changeSubject(naslovi[0])">
                Naslov 1
              </button>
              <button class="option-btn" @click="changeSubject(naslovi[1])">
                Naslov 2
              </button>
              <button class="option-btn" @click="changeSubject(naslovi[2])">
                Naslov 3
              </button>
            </div>
            <p class="disclamer">
              *ovo su generički primeri, pozivamo ih da ih klikom preuredite ili
              u potponosti sami napišite, kako bi svaki izgledao drugačije!
            </p>
            <input
              type="text"
              v-model="subject"
              name="subject"
              placeholder="Naslov email-a"
            />
            <p v-if="subjectError" class="error">Ovo polje je obavezno!</p>
          </div>
          <div class="container-item">
            <label>Poruka</label>

            <p class="clickp">
              Klikom na dugmiće ispod možete izabrati neke od predloga poruka
            </p>
            <div class="buttons">
              <button class="option-btn" @click="changeMsg(poruke[0])">
                Poruka 1</button
              >.
              <button class="option-btn" @click="changeMsg(poruke[1])">
                Poruka 2
              </button>
              <button class="option-btn" @click="changeMsg(poruke[2])">
                Poruka 3
              </button>
            </div>

            <p class="disclamer">
              *ovo su generički primeri, pozivamo ih da ih klikom preuredite ili
              u potponosti sami napišite, kako bi svaki izgledao drugačije!
            </p>
            <textarea
              name="message"
              v-model="message"
              cols="30"
              rows="5"
              placeholder="Poštovani..."
            >
            </textarea>
            <p v-if="msgError" class="error">Ovo polje je obavezno!</p>
          </div>
          <div class="container-item">
            <a
              v-bind:href="
                'mailto:?bcc=dragoljub.ackovic@parlament.rs,stefan.adzic@parlament.rs,zagorka.aleksic@parlament.rs,ivan.antic@parlament.rs,radovan.arezina@parlament.rs,veroljub.arsic@parlament.rs,marko.atlagic@parlament.rs,andrijana.avramov@parlament.rs,muamer.bacevac@parlament.rs,dusan.bajatovic@parlament.rs,zivan.bajic@parlament.rs,nebojsa.bakarec@parlament.rs,igor.becic@parlament.rs,ana.beloicamartac@parlament.rs,marko.bogdanovic@parlament.rs,natasa.bogunovic@parlament.rs,milorad.bojovic@parlament.rs,miloratka.bojovic@parlament.rs,nikola.bokan@parlament.rs,sandra.bozic@parlament.rs,igor.braunovic@parlament.rs,zika.bujuklic@parlament.rs,dejan.bulatovic@parlament.rs,slavisa.bulatovic@parlament.rs,nebojsa.cakic@parlament.rs,aleksandar.cotric@parlament.rs,sanja.calovic@parlament.rs,zoltan.dani@parlament.rs,tijana.davidovac@parlament.rs,biljana.dragic@parlament.rs,zoran.dragisic@parlament.rs,milovan.drecun@parlament.rs,edis.durgutovic@parlament.rs,vladimir.djukanovic@parlament.rs,vladimir.djukic@parlament.rs,nevena.djuric@parlament.rs,ljubinko.djurkovic@parlament.rs,milica.djurdjevicstamenkovski@parlament.rs,rozalija.ekres@parlament.rs,ninoslav.eric@parlament.rs,jahja.fehratovic@parlament.rs,dubravka.filipovski@parlament.rs,gorica.gajic@parlament.rs,milan.glusac@parlament.rs,zika.gojkovic@parlament.rs,ugljesa.grgur@parlament.rs,jasmin.hodzic@parlament.rs,dejan.ignјatovic@parlament.rs,dejan.ilic@parlament.rs,biljana.ilic-stosic@parlament.rs, natasa.ivanovic@parlament.rs,lepomir.ivkovic@parlament.rs,vesna.ivkovic@parlament.rs,tomislav.jankovic@parlament.rs,stanislava.janoševic@parlament.rs,sanja.jeficbrankovic@parlament.rs,aleksandar.jerkovic@parlament.rs,marija.jevdjic@parlament.rs,sandra.jokovic@parlament.rs,nemanja.joksimovic@parlament.rs,branislav.josifovic@parlament.rs,milenko.jovanov@parlament.rs,aleksandar.jovanovic@parlament.rs,branimir.jovanovic@parlament.rs,darko.jovanovic@parlament.rs,dragan.jovanovic@parlament.rs,jadranka.jovanovic@parlament.rs,marija.jovanovic@parlament.rs,milos.jovanovic@parlament.rs,natasa.jovanovic@parlament.rs,tatjana.jovanovic@parlament.rs,aleksandar.jugovic@parlament.rs,jelena.kalajdzic@parlament.rs,jasmina.karanac@parlament.rs,dragomir.karic@parlament.rs,ivan.karic@parlament.rs,jovan.kolundzija@parlament.rs,djordje.komlenski@parlament.rs,miroslav.kondic@parlament.rs,djordje.kosanic@parlament.rs,elvira.kovac@parlament.rs,borisav.kovacevic@parlament.rs,dubravka.kralj@parlament.rs,stefan.krkobabic@parlament.rs,darko.laketic@parlament.rs,sanja.lakic@parlament.rs,miodrag.linta@parlament.rs,dragana.lukic@parlament.rs,mirka.lukic-sarkanovic@parlament.rs,nada.macura@parlament.rs,dejan.manic@parlament.rs,dusan.maric@parlament.rs,aleksandar.markovic@parlament.rs,dragan.d.markovic@parlament.rs,dragan.m.markovic@parlament.rs,ugljesa.markovic@parlament.rs,predrag.marsenic@parlament.rs,jana.mateovic@parlament.rs,veroljub.matic@parlament.rs,tatjana.medved@parlament.rs,vojislav.mihailovic@parlament.rs,ilo.mihajlovski@parlament.rs,djordje.miketic@parlament.rs,milija.miletic@parlament.rs,goran.milic@parlament.rs,svetlana.milijic@parlament.rs,dragovan.milinkovic@parlament.rs,jelena.milivojevic@parlament.rs,srdjan.milivojevic@parlament.rs,ana.miljanic@parlament.rs,milosav.milojevic@parlament.rs,aleksandar.mirkovic@parlament.rs,nenad.а.mitrovic@parlament.rs,marko.mladenovi@parlament.rs,ugljesa.mrdic@parlament.rs,vesna.nedovic@parlament.rs,nikola.nesic@parlament.rs,danijela.nestorovic@parlament.rs,ivana.nikolic@parlament.rs,milica.nikolic@parlament.rs,milinka.nikolic@parlament.rs,ratko.nikoli@parlament.rs,jasmina.obradovic@parlament.rs,jelena.obradovic@parlament.rs,milica.obradovic@parlament.rs,aleksandar.olenik@parlament.rs,vladimir.orlic@parlament.rs,mirko.ostrogonac@parlament.rs,jovan.palalic@parlament.rs,biljana.panticpilja@parlament.rs,balint.pastor@parlament.rs,snezana.paunovic@parlament.rs,borislava.peric-rankovic@parlament.rs,olja.petrovic@parlament.rs,tamara.pilipovic@parlament.rs,nenad.popovic@parlament.rs,dejan.radenkovic@parlament.rs,stojan.radenovic@parlament.rs,milan.radin@parlament.rs,dragana.radinovic@parlament.rs,dusan.radojevic@parlament.rs,zoran.radojicic@parlament.rs,dusan.radosavljevic@parlament.rs,nikola.radosavljevic@parlament.rs,dijana.radovic@parlament.rs,marina.ragus@parlament.rs,zaim.redzepovic@parlament.rs,marko.ristic@parlament.rs,marijan.risticevic@parlament.rs,nenad.ristovic@parlament.s,zoran.sandic@parlament.rs,andreja.savic@parlament.rs,vesna.savovic.petkovic@parlament.rs,srdjan.simic@parlament.rs,dunja.simonovic.bratic@parlament.rs,ivana.srbulovic@parlament.rs,rodoljub.stanimirovic@parlament.rs,zivota.starcevic@parlament.rs,veroljub.stevanovic@parlament.rs,dragan.stojanovic@parlament.rs,stasa.stojanovic@parlament.rs,zoran.stojanovic@parlament.rs,dusan.stojiljkovic@parlament.rs,momir.stojilkovic@parlament.rs,hadzi.milorad.stosic@parlament.rs,dalibor.scekic@parlament.rs,dejan.sulkic@parlament.rs,natasa.tasic.knezevic@parlament.rs,djordje.todorovic@parlament.rs,marija.todorovic@parlament.rs,nenad.tomasevic@parlament.rs,aleksandra.tomic@parlament.rs,zoran.tomic@parlament.rs,bojan.torbica@parlament.rs,radovan.tvrdisic@parlament.rs,akos.ujhelji@parlament.rs,zombor.ujvari@parlament.rs,andrijana.vasic@parlament.rs,dejana.vasic@parlament.rs,bratimir.vasiljevic@parlament.rs,draginja.vlk@parlament.rs,marija.vojinovic@parlament.rs,svetozar.vujacic@parlament.rs,milimir.vujadinovic@parlament.rs,vojislav.vujic@parlament.rs,danijela.vujicic@parlament.rs,branko.vukajlovic@parlament.rs,momcilo.vuksanovic@parlament.rs,dragan.vulic@parlament.rs,vladan.zagradanin@parlament.rs,nebojsa.zelenovic@parlament.rs,usame.zukorlic@parlament.rs,jelena.zaric.kovacevic@parlament.rs,pg.sns@parlament.rs,sps@parlament.rs, pg.nada-novidss-poks@parlament.rs, pg.jedinstvenasrbija@parlament.rs, pg.moramozajedno@parlament.rs, pg.sdps@parlament.rs, pg.pups@parlament.rs, pg.zapomirenje@parlament.rs, pg.svm@parlament.rs, muamerbacevac77@gmail.com,beloicaana@gmail.com, natasa.bogunovic@dragisamisovic.bg.ac.rs, bratimirvasiljevic@gmail.com, vasicdejana5@gmail.com, gagavlk@gmail.com, milimir_vujadinovic@yahoo.com, davidovac.t.j.i@gmail.com, ediskg83@gmail.com, nevenadjuricks@gmail.com, ninoslav.eric@gmail.com, stanislava.janosevic@gmail.com, jovanovicdare@gmail.com, nemanja.joksimovic@sns.org.rs, branislav.josifovic@knjazevac.rs, shaipk@yahoo.com, jasmina.karanac@gmail.com, dragomir.j.karic@bk.ru, djordjekosanickg@gmail.com, draganailic1988@gmail.com, dusan.jojic.maric@gmail.com, djordje.miketic@gmail.com, milijamiletic@gmail.com, gmilic28@gmail.com, ana.miljanic@pozarevac.rs, amkasper127@gmail.com, nikola.d.nesic@gmail.com, ivananikolicsf@gmail.com, novakovicb64@gmail.com, biljapantic11@gmail.com, paunovicsnezana@yahoo.com, sps@parlament.rs, oljapetrovic25@yahoo.com, dejan.radenkovic71@gmail.com, milanradin988@gmail.com, andreja.savic@hotmail.rs, vesna.savovic11@gmail.com, stasasns@gmail.com, stomil54@yahoo.com, natasatasic@yahoo.com, todorovic.marija505@gmail.com, zoranzoca@gmail.com, torbicamb@gmail.com, sanjacalovic@gmail.com, ujhelyi.akos@gmail.com, jasminhodzic83@yahoo.com, gorica017@yahoo.com, poslanik1@gmail.com, markob@dr.com, kabinet@srbijasume.rs, andrijana.le.92@gmail.com, vladandjukic11@gmail.com, pg.moramozajedno@parlament.rs, igorcirkovic80@gmail.com, milicaradojkovic19@live.com, rodoljubazanja@gmail.com, djole_43@yahoo.com, drecunm@yahoo.com, dragana.radinovic05@gmail.com, bakarecnebojsa@gmail.com, direktor@olorinpress.rs, danijela.vujic2011@gmail.com, bujuklic@ius.bg.ac.rs, pilipovictamara90@gmail.com, beloicaana@gmail.com, slavissabulatovic@gmail.com, torbicamb@gmail.com , ivantic35@gmai.com , djole_43@yahoo.com, nevenadjuricks@gmail.com , natasa.sp.jovanovic@gmail.com, paunovicsnezana@gmail.com, danizo117@gmail.com, kabinet@srbijasume.rs, ugljesa.grgur@gmail.com, milosjovanovic@ius.bg.ac.rs, vojislav.mihailovic@poks.rs, djordjekosanickg@gmail.com, kivtajs@gmail.com&subject=' +
                subject +
                '&body=' +
                message
              "
              class="sendBtn"
              >Pošalji email preko svog naloga</a
            >
            <p class="website-desc">
              Zbog velikog broja mejlova na koje se šalju poruke, moguće je jedino slanje preko mobilnih uređaja.
            </p>
            <!-- <p class="website-desc">
              Gradsku vlast plaćamo mi i zato crpimo pravo da im se obratimo sa
              zahtevom da se slušaju naše potrebe. Možda nas ne čuju kada im se
              obraćamo pojedinačno, ali svi zajedno jesmo glas koji nije moguće
              preskočiti, svi zajedno jesmo onaj glas koji donosi razliku!
            </p> -->
            <p class="disclamer">
              Ne odgovaramo za neprimerene komentare, uvrede i moguće
              zloupotrebe ovog kanala za pisanje gradskim vlastima. Apelujemo na
              građane da i ovom prilikom budemo dostojanstveni i pristojni, da
              budemo iskreni i istrajni, ali da ne dozvolimo bilo kakve uvrede,
              pretnje i neprimerene komentare. Želimo pristojnu Srbiju i za nju
              se borimo na takav način!
            </p>
          </div>
        </div>
        <div v-if="msgSent" class="msgSent">
          <h3>Hvala vam što ste poslali poruku RTS-u!</h3>
          <a href="#" class="sendBtn" @click="sendAgain()">Pošalji ponovo</a>
        </div>
        <!-- <p class="last-p">
        last p
      </p> -->
      </div>
    </div>
    <div class="legend">
      <pie-chart
        height="250px"
        :donut="true"
        :colors="['#1fc481', '#EF3636', '#F67618']"
        :data="[
          ['Podržali', votedCount.yes],
          ['Nisu podržali', votedCount.no],
          ['Ignorišu', votedCount.declined],
        ]"
      ></pie-chart>
    </div>
    <div></div>

    <h3>Sortiraj poslanike po poslaničkom klubu:</h3>
    <div class="filters">
      <div
        class=""
        v-for="party in partyFilters"
        :key="party.id"
        @click="filterByParty(party)"
      >
        <button :class="isSelected(party)" class="button">{{ party }}</button>
      </div>
    </div>
    <h3>Pretraži poslanika po imenu:</h3>
    <div class="searchMember">
      <input type="text" v-model="searchInput" class="inputSearch" />
      <button @click="deleteSearch()" class="delete">X</button>
    </div>
    <div class="members">
      <div
        class="member-card"
        v-for="parlamentMember in listRender"
        :key="parlamentMember.id"
      >
        <div class="img">
          <div v-if="parlamentMember.attributes.picture.data != null">
            <img
              class="member-img"
              :src="parlamentMember.attributes.picture.data.attributes.url"
            />
          </div>
          <div v-else>
            <img class="member-img" src="./../assets/m1.webp" />
          </div>
        </div>
        <p class="firstname-lastname">{{ parlamentMember.attributes.Name }}</p>
        <div class="member-data">
          <p class="party">
            {{ parlamentMember.attributes.Party }},
            {{ parlamentMember.attributes.City }}, ({{
              parlamentMember.attributes.Year
            }})
          </p>
        </div>
        <div v-if="parlamentMember.attributes.votedr === 'yes'">
          <p class="voted v">
            <img src="./../assets/up.png" alt="" />
            Podržao/la
          </p>
        </div>
        <!-- <div v-if="parlamentMember.attributes.volunteerPic.data !== null">
          <button class="show-pic" @click="showPic(parlamentMember.id)">
            Prikaži sliku
          </button>
        </div> -->
        <div class="showImg" v-if="showPicId === parlamentMember.id">
          <button class="close" @click="closePic()">zatvori</button>
          <img
            :src="parlamentMember.attributes.volunteerPic.data.attributes.url"
            alt=""
          />
        </div>
        <div v-if="parlamentMember.attributes.votedr === 'no'">
          <p class="voted-no v">
            <img src="./../assets/down.png" alt="" />Nije podržao/la
          </p>
        </div>
        <div v-if="parlamentMember.attributes.votedr === 'denied-call'">
          <p class="voted-declined v">
            <img src="./../assets/declined.png" alt="" />IGNORIŠE.
          </p>
        </div>
        <div v-if="parlamentMember.attributes.voted == null">
          <div class="blank"></div>
        </div>
      </div>
    </div>
    <div v-if="checkShowMore()">
      <button class="showMore" @click="showMore()">Prikaži još</button>
    </div>
    <div class="footer">
      <div class="socials">
        <p>
          <a href="https://www.instagram.com/kreni.promeni/" target="_blank"
            ><img src="./../assets/insta.png" alt=""
          /></a>
        </p>
        <p>
          <a href="https://www.facebook.com/kreni.promeni/" target="_blank"
            ><img src="./../assets/facebook.png" alt=""
          /></a>
        </p>
        <p>
          <a href="https://twitter.com/kpromeni" target="_blank"
            ><img src="./../assets/twitter.png" alt=""
          /></a>
        </p>
        <p>
          <a href="https://peticije.kreni-promeni.org/" target="_blank"
            ><img src="./../assets/web.png" alt=""
          /></a>
        </p>
      </div>
      <h3>KRENI-PROMENI © 2022. All rights reserved.</h3>

      <img
        v-if="scrollFromTop > 750"
        src="./../assets/top-angle-arrow-bold-icon.png"
        @click="topFunction()"
        id="myBtn"
        title="Go to top"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HelloWorld",
  props: {},
  data() {
    return {
      parlamentMembers: [],
      mL: 0,
      showPicId: 0,
      searchInput: "",
      partyFilters: [
        "SVI",
        "SNS",
        "DVERI",
        "DS",
        "NARODNA STRANKA",
        "JS",
        "MORAMO ZAJEDNO",
        "NADA - NOVI DSS - POKS",
        "SPS",
        "SVM",
        "UJEDINJENI",
        "ZAVETNICI",
        "SDPS",
        "PUPS",
        "NARODNI POSLANICI KOJI NISU ČLANOVI POSLANIČKIH GRUPA",
        "ZELENO-LEVI KLUB, NE DAVIMO BEOGRAD-MORAMO",
      ],
      selectedMembers: [],
      selectedParty: "",
      listLenght: 12,
      scrollFromTop: 0,
      emailCountNumber: 0,
      name: "",
      userEmail: "",
      email: "",
      subject: "",
      message: "",
      msgSent: false,
      naslovi: [
        "Slagali da je ukinut rijaliti",
        "Veliki brat u Zadruzi",
        "Sta je sa Narodnom inicijativom???",
      ],
      poruke: [
        "Više od 36 000 građana je predložilo Zakon o ograničavanju rijaliti programa i uvođenju pola sata kulturnog programa za decu i pola sata kulturnog programa za maloletnike. Ti građani čekaju Vaš odgovor. Stavite Zakon na glasanje!",
        "Prvi trenutak da rešimo problem rijalitija bio je 2006. godine kada je taj koncept došao u Srbiju. Drugi trenutak je sada. Stavite na glasanje Zakon o ograničavanju rijaliti programa i uvođenju pola sata kulturnog programa za decu i pola sata kulturnog programa za maloletnike koji je predložilo više od 36 000 građana i ispunite jedan od zahteva protesta.",
        "Ne verujemo praznim obećanjima vlasti o ukidanju rijalitija. Jedini način da zaista stanemo na put emitovanju jeste zakonsko rešenje koje je u Narodnoj skupštini od 2019. Godine. Građani očekuju Vaš odgovor.",
      ],
      nameError: false,
      emailError: false,
      subjectError: false,
      msgError: false,
    };
  },
  computed: {
    filterMembers() {
      let filter = this.selectedParty;
      let filteredMembers = [];
      if (this.selectedParty === "SVI") {
        filteredMembers = this.parlamentMembers;
        return filteredMembers;
      } else {
        filteredMembers = this.parlamentMembers.filter(function (membmer) {
          if (membmer.attributes.Party === filter) {
            return true;
          } else {
            return false;
          }
        });
        return filteredMembers;
      }
    },
    listRender() {
      let memberlist = this.filterMembers.slice(0, this.listLenght);
      if (this.searchInput !== "") {
        return this.filterMembers.filter((item) => {
          return item.attributes.Name.toLowerCase().includes(
            this.searchInput.toLowerCase()
          );
        });
      } else {
        return memberlist;
      }
      // return memberlist;
    },
    votedCount() {
      let yes = this.selectedMembers.filter(function (membmer) {
        if (
          membmer.attributes.votedr === "yes" &&
          membmer.attributes.votedr !== null
        ) {
          return true;
        } else {
          return false;
        }
      }).length;
      let no = this.selectedMembers.filter(function (membmer) {
        if (
          membmer.attributes.votedr === "no" &&
          membmer.attributes.votedr !== null
        ) {
          return true;
        } else {
          return false;
        }
      }).length;
      let declined = this.selectedMembers.filter(function (membmer) {
        if (
          membmer.attributes.votedr === "denied-call" &&
          membmer.attributes.votedr !== null
        ) {
          return true;
        } else {
          return false;
        }
      }).length;
      return { yes: yes, no: no, declined: declined };
    },
  },
  watch: {
    selectedParty: function () {
      if (this.filterMembers !== null) {
        this.selectedMembers = this.filterMembers;
      }
    },
  },
  methods: {
    deleteSearch: function () {
      this.searchInput = "";
    },
    scrollFunction: function () {
      this.scrollFromTop =
        window.pageYOffset ||
        (document.documentElement || document.body.parentNode || document.body)
          .scrollTop;
    },
    topFunction: function () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    showMore: function () {
      if (this.listRender.length <= this.listLenght) {
        this.listLenght += 12;
      }
    },
    filterByParty: function (party) {
      this.selectedParty = party;
      this.listLenght = 12;
    },
    filterByVote: function (vote) {
      console.log(vote);
    },
    isSelected: function (party) {
      if (party === this.selectedParty) {
        return "active";
      } else {
        return "";
      }
    },
    checkShowMore: function () {
      if (this.listRender.length >= this.listLenght) {
        return true;
      } else {
        return false;
      }
    },
    showPic(key) {
      this.showPicId = key;
    },
    closePic() {
      this.showPicId = 0;
    },
    changeSubject: function (subject) {
      this.subject = subject;
    },
    changeMsg: function (msg) {
      this.message = msg;
    },
    sendEmail: function () {
      if (this.name !== "") {
        this.nameError = false;
        if (this.userEmail !== "") {
          this.emailError = false;
          if (this.subject !== "") {
            this.subjectError = false;
            if (this.message !== "") {
              this.msgError = false;
              axios
                .get(
                  "https://hooks.zapier.com/hooks/catch/9841582/bcymshf/?name='" +
                    this.name +
                    "'&userEmail='" +
                    this.userEmail +
                    "'&subject='" +
                    this.subject +
                    "'&msg=" +
                    this.message +
                    "'"
                )
                .then((response) => {
                  console.log(response);
                  axios
                    .get(
                      "https://podeli-promeni-backend.herokuapp.com/email-counts/63338b2d51d08227904f7a7c"
                    )
                    .then((response) => {
                      axios
                        .put(
                          "https://podeli-promeni-backend.herokuapp.com/email-counts/63338b2d51d08227904f7a7c",
                          {
                            count: parseInt(response.data.count) + 1,
                          }
                        )
                        .then(() => {
                          this.getEmailCount();
                        });
                    });
                });
              this.msgSent = true;
            } else {
              this.msgError = true;
            }
          } else {
            this.subjectError = true;
          }
        } else {
          this.emailError = true;
        }
      } else {
        this.nameError = true;
      }
    },
    sendAgain: function () {
      this.message = "";
      this.subject = "";
      this.msgSent = false;
    },
    getEmailCount: function () {
      axios
        .get(
          "https://podeli-promeni-backend.herokuapp.com/email-counts/63338b2d51d08227904f7a7c"
        )
        .then((response) => {
          return (this.emailCountNumber = response.data.count);
        });
    },
  },
  async beforeMount() {
    await axios
      .get(
        "https://poslanici-backedn.herokuapp.com/api/parlament-members?populate=*"
      )
      .then(
        (response) =>
          (this.parlamentMembers = response.data.data.sort(function (a, b) {
            return a.id - b.id;
          }))
      );
    this.selectedParty = "SVI";
    document.addEventListener("scroll", this.scrollFunction);
    this.mL = this.parlamentMembers.lenght;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.members {
  padding: 20px 5%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 1%;
  row-gap: 30px;
  margin-top: 70px;
}
.members::-webkit-scrollbar {
  display: none;
}
.member {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
}
.firstname-lastname {
  padding: 0;
  margin: 0;
  margin-top: 60px;
  font-size: 1.2em;
  text-transform: capitalize;
}
.member-card {
  border-radius: 5px;
  position: relative;
  padding-top: 50px;
  margin: 20px;
  border-radius: 10px;
  background: #14223b;
  color: white;
}
.blank {
  height: 40px;
  width: 100%;
  display: block;
}
.member-img {
  border-radius: 500%;
  position: absolute;
  top: 25px;
  overflow: hidden;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 15px 35px -15px rgba(0, 0, 0, 0.5);
  width: 120px;
  display: block;
}
.member-data {
  padding: 0;
  grid-template-columns: 1fr 1fr 1fr;
  margin-top: 5px;
  font-family: "Nunito", sans-serif;
  /* background: yellow; */
}
.member-data p {
  font-size: 1em;
  margin: 0;
}
.hello {
  height: auto;
}
.voted {
  color: #68e4b1;
  font-weight: bolder;
  font-size: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  text-transform: uppercase;
}
.voted i {
  font-size: 25px;
}
.voted-no {
  color: #ef3636;
  font-weight: bolder;
  font-size: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  text-transform: uppercase;
}
.voted-no i {
  font-size: 25px;
}
.voted-declined {
  color: #f67618;
  font-weight: bolder;
  font-size: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
  text-transform: uppercase;
}
.v i {
  font-size: 25px;
  padding: 10px;
}
.v img {
  width: 40px;
  padding: 10px;
  margin: 5px auto;
}
.header {
  margin: 0;
  border-bottom: 1px solid #c8c8c8;
  background: #213861;
  display: flex;
  justify-content: space-between;
}
.header img {
  height: 100px;
  display: block;
  margin: 0 auto;
}
.description {
  font-size: 20px;
  width: 60%;
  padding: 20px;
  margin: 20px auto;
  font-weight: 600;
  max-width: 800px;
  text-align: justify;
}

@media only screen and (max-width: 600px) {
  .header img {
    height: 50px;
    display: block;
    margin: 0 auto;
  }
  .v {
    font-size: 15px;
    /* padding: 10px; */
  }
  .members {
    padding: 20px 5%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    /* grid-gap: 1%; */
    /* row-gap: 30px; */
    margin-top: 70px;
  }
  .firstname-lastname {
    font-size: 13px;
  }
  .member-data p {
    font-size: 10px;
  }
  .member-card {
    margin: 5px;
  }
  .description {
    font-size: 14px;
    width: 90%;
  }
  .button {
    font-size: 10px;
  }
}

#myBtn {
  position: fixed;
  bottom: 5%;
  z-index: 1000;
  padding: 20px;
  width: 50px;
  right: 5%;
  /* background-color: white; */
  /* color: #14223b; */
}
#myBtn:hover {
  cursor: pointer;
}
.filters {
  display: flex;
  flex-direction: row;
  width: 90%;
  margin: 0 auto;
  justify-content: center;
  flex-wrap: wrap;
}
.button {
  padding: 15px;
  margin: 5px;
  display: blok;
  font-weight: bold;
  text-transform: uppercase;
  border: 0px solid #213861;
  border-radius: 10px;
  background: #14223b;
  color: white;
}
.filters button:hover {
  cursor: pointer;
}
.active {
  background: #efd662;
  color: #14223b;
}
.showMore {
  padding: 15px 25px;
  margin: 5px;
  display: blok;
  font-weight: bold;
  text-transform: uppercase;
  border: 0px solid;
  border-radius: 10px;
  background: #213861;
  color: white;
  font-weight: bolder;
}
.showMore:hover {
  cursor: pointer;
}
.footer {
  width: 100%;
  min-height: 100px;
  background: #213861;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  padding-bottom: 20px;
  position: relative;
}
.footer h3 {
  margin: 0;
  font-weight: 400;
  font-size: 12px;
  color: white;
}
.socials {
  display: flex;
}
.socials p {
  padding: 10px 5px;
  color: white;
}
.socials p a img {
  width: 35px;
}
.inputSearch {
  font-size: 20px;
  padding: 5px;
}
.delete {
  padding: 10px;
  margin: 5px;
  background: #ef3636;
  color: white;
  cursor: pointer;
  border: none;
}
.searchMember {
  display: flex;
  justify-content: center;
  align-items: center;
}

.show-pic {
  padding: 10px 15px;
  font-size: 15px;
  background: #efd662;
  color: #14223b;
  font-weight: bolder;
  border: none;
  margin-bottom: 20px;
  /* margin-top: 25px; */
  border-radius: 25px;
}
.showImg {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  top: 0;
  text-align: center;
  max-width: 100%;
  /* padding: 20px; */
  min-height: 100%;
  z-index: 10000;
  /* background: rgba(0, 0, 0, 0.445); */
}
.showImg img {
  /* display: inline-block; */
  max-width: 100%;
}
.close {
  position: absolute;
  background: #ef3636;
  border-radius: 10px;
  padding: 10px;
  font-size: 15px 25px;
  color: white;
  font-weight: bolder;
  border: none;
  top: 20px;
  right: 20px;
}
.close:hover {
  cursor: pointer;
}

.container {
  padding: 25px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* max-width: 900px;
  margin: 0 auto; */
}
.container .container-item input,
textarea {
  display: block;
  padding: 10px 0px;
  padding-left: 10px;
  font-size: 15px;
  width: 100%;
  max-width: 750px;
}
.container-item p {
  width: 100%;
}
textarea {
  min-height: 150px;
}
label {
  text-align: left;
  display: block;
  width: 100%;
  font-size: 20px;
  margin-top: 15px;
  margin-bottom: 10px;
  max-width: 750px;
  font-weight: bolder;
}
.container-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.buttons {
  display: flex;
  font-size: 15px;
  width: 100%;
  max-width: 750px;
  margin-left: -5px;
}
.buttons button {
  padding: 7px;
  font-size: 15px;
  font-weight: bolder;
  border-radius: 5px;
  margin-right: 10px;
}
.buttons button:hover {
  cursor: pointer;
}
.sendBtn {
  background: #14a466;
  border-radius: 5px;
  color: white;
  font-size: 17px;
  font-weight: bolder;
  padding: 15px;
  border: none;
  margin-top: 15px;
  display: inline-block;
  text-decoration: none;
}
.sendBtn:hover {
  cursor: pointer;
}

.disclamer {
  color: #fc7f80;
  text-align: justify;
  max-width: 750px;
  margin: 0 auto;
  margin-top: 20px;
}
.option-btn {
  background-color: #182338;
  color: white;
  border: none;
}
.error {
  color: #f74343;
  font-style: italic;
}
.disclamer {
  font-style: italic;
  color: #f74343;
}
.msgSent h3 {
  margin-top: 20px;
}
.last-p {
  width: 100%;
  margin: 10px auto;
  max-width: 750px;
  /* padding: 0 10px; */
  text-align: justify;
  font-size: 1em;
  font-weight: 400;
}
.msg {
  /* font-size:  */
  text-align: center;
}
.countNumber {
  margin-top: 5px;
  font-size: 1.3em;
  font-weight: 900;
}
.website-desc {
  width: 100%;
  margin: 10px auto;
  max-width: 510px;
  text-align: justify;
  /* max-width: 50%; */
  font-size: 1em;
  /* font-size: 19px; */
}
.clickp {
  text-align: left;
}
</style>
